import { render, staticRenderFns } from "./ramp.vue?vue&type=template&id=12b9bda6&scoped=true"
import script from "./ramp.vue?vue&type=script&lang=js"
export * from "./ramp.vue?vue&type=script&lang=js"
import style0 from "./ramp.vue?vue&type=style&index=0&id=12b9bda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9bda6",
  null
  
)

export default component.exports